import { Button, Divider, Drawer, ScrollbarStyles, styled } from 'hyarchis-global';

const FlexBox = styled.div`
  display: flex;
`;

const StyledDrawer = styled(Drawer)`
  .drawer-wrapper > div:first-child {
    height: auto;
  }
`;

const StyledDivider = styled(Divider)`
  margin: 0;
`;

const StyledAddDrawerButton = styled(Button)`
  width: 15%;
  margin: 10px;
`;

const StyledMatchModalButton = styled(Button)`
  width: 80%;
  margin: 2px;
`;

const StyledAddButton = styled(Button)`
  margin-top: 15px;
  width: 100%;
`;

const StyledButton = styled(Button)`
  && {
    color: ${(props) => props.theme.colors.topBarText};
    border: none;
    background-color: transparent;
    box-shadow: none;

    :hover,
    :focus {
      color: ${(props) => props.theme.colors.topBarText};
      border: none;
      background-color: transparent;
    }
  }
`;

const StyledExternalSourceData = styled(Button)`
  width: 10%;
`;

const FormGroup = styled.div`
  border-top: 1px solid ${(props) => props.theme.colors.border};
  padding: 10px;
`;

const StyledLabel = styled.label`
  flex: 0 0 auto;
  margin-top: 10px;
`;

const StyledMarginLeftLabel = styled(StyledLabel)`
  margin-left: 5px;
`;

const StyledButtonText = styled.span`
  margin: auto 8px;
`;

const StyledText = styled.span`
  margin: auto 8px;
  color: ${(props) => props.theme.colors.topBarText};
`;

const StyledScrollbar = styled.div`
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  ${ScrollbarStyles}
`;

const StyledActionsWrapper = styled.div`
  display: inline-flex;
  gap: 10px;
  align-items: center;
`;

const StyledAddButtonWrapper = styled.div`
  margin: 10px 16px;
  text-align: right;
`;

const StyledMatchModalButtonsWrapper = styled(FlexBox)`
  font-weight: normal;
  font-size: 16px;
  display: flex;
  align-items: center;
  width: 100px;
  height: 25px;
`;

const StyledMatchModalConfirmationWrapper = styled(StyledMatchModalButtonsWrapper)`
  font-size: 10px;
`;

export default {
  StyledDrawer,
  StyledDivider,
  StyledButton,
  StyledButtonText,
  StyledScrollbar,
  StyledActionsWrapper,
  StyledAddButtonWrapper,
  StyledAddDrawerButton,
  StyledAddButton,
  StyledText,
  StyledLabel,
  StyledMarginLeftLabel,
  StyledMatchModalButton,
  StyledMatchModalButtonsWrapper,
  StyledMatchModalConfirmationWrapper,
  FormGroup,
  StyledExternalSourceData,
};
